import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=ecfff36a&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=ecfff36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfff36a",
  null
  
)

export default component.exports